import { ENetwork, web3Configs } from 'web3';

export const geckoterminalLink = ({
  network,
  pairAddress,
}: {
  network: ENetwork;
  pairAddress: string;
}) => {
  const { geckoterminalSlug } = web3Configs[network];

  if (!geckoterminalSlug) return undefined;

  const url = `https://www.geckoterminal.com/${geckoterminalSlug}/pools/${pairAddress}`;

  return url;
};
